import type { ReactNode } from "react";
import css from "./SplitView.module.css";

/**
 * Responsive master-detail layout (ADR 131). Below the wide breakpoint it is a
 * single column and the detail stacks under the list only when something is
 * selected (`detailOpen`); at ≥1280px it becomes two panes — list on the left,
 * a sticky detail on the right that always shows (its own empty state when
 * nothing is selected). Pages own their own max-width; this only splits.
 *
 * `--split-detail-width` (default 340px) sets the detail column on wide screens.
 */
export function SplitView({ list, detail, detailOpen = false, detailLabel }: {
  list: ReactNode;
  detail: ReactNode;
  detailOpen?: boolean;
  detailLabel?: string;
}) {
  return (
    <div className={css.split}>
      <div className={css.list}>{list}</div>
      <aside className={css.detail} data-open={detailOpen} aria-label={detailLabel}>
        {detail}
      </aside>
    </div>
  );
}
